import {
  GET_CARGO2_LIST,
  GET_CARGO2_LIST_SUCCESS,
  GET_CARGO2_LIST_FAIL,
} from "src/constants/types";

export const cargo2Reducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_CARGO2_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_CARGO2_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        cargo2List: actions.payload,
        error: "",
      };
    case GET_CARGO2_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
